import { Alert } from 'antd';
import { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';

import { DEFAULT_DATE_FORMAT, isUnusualHour, TIME_FORMAT } from '@/utils';

type TimeWarningsProps = {
  selectedDate: Dayjs | null;
};

export function TimeWarnings({ selectedDate }: TimeWarningsProps) {
  const { t } = useTranslation();

  const showUnusualTimeWarning = isUnusualHour(selectedDate);

  if (!showUnusualTimeWarning || !selectedDate) {
    return null;
  }

  const formattedDate = selectedDate.format(DEFAULT_DATE_FORMAT);
  const formattedTime = selectedDate.format(TIME_FORMAT);

  return (
    <Alert
      type='warning'
      title={t('common:unusualTimeWarning', {
        date: formattedDate,
        time: formattedTime,
      })}
      showIcon
    />
  );
}
